import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Contact from "../../components/home/Contact";
import Partners from "../../components/home/Partners";
import Review from "../../components/home/Review";
import Service from "../../components/home/Service";
import useScript from "../../const/useScript";

const Transform = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.code === "0000") setData(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useScript("https://www.googletagmanager.com/gtag/js?id=AW-18424499366");

  useEffect(() => {
    const google = document.createElement("script");
    google.async = true;
    google.innerHTML = `gtag('event', 'conversion', { 'send_to': 'AW-18424499366/X5dKCKrklfAcEKaZvtFE', 'value': 1.0, 'currency': 'KRW' });`;

    document.body.appendChild(google);
    return () => {
      document.body.removeChild(google);
    };
  }, []);

  return (
    <>
      <Banner />
      <About />
      <Service />
      <Blog data={data} />
      <Review />
      <Contact />
      <Partners />
    </>
  );
};

export default Transform;
